import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { signOut } from "firebase/auth";
import { useAuth } from './AuthContext';
import { auth } from './firebase';
import AppHeader from './AppHeader';

function AppLayout() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut(auth)
      .then(() => navigate("/login"))
      .catch((error) => console.error("Sign out error:", error));
  };

  return (
    <div className="app-container">
      <AppHeader currentUser={currentUser} onSignOut={handleSignOut} />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;